export default "__VITE_ASSET__CDZD4h99__"